import { createAsyncThunk } from '@reduxjs/toolkit';
import { errorGlobal, successGlobal } from '../reducers/notifications';
import { getAuthHeader } from '../../utils/tools';
import axios from 'axios';

axios.defaults.headers.post['Content-Type'] = 'application/json';

// Get Tenant
export const getTenant = createAsyncThunk(
    'tenant/getTenant',
    async(currentBranch, { dispatch }) => {
        try {
            const request = await axios.get(`/api/tenant/get`, {
                params: { branchId: currentBranch },
                ...getAuthHeader()
            });

            return request.data;

        } catch(error) {
            dispatch(errorGlobal('Nepodarilo sa načítať informácie o subjekte.'));
            throw error;
        }
    }
);

// Fetch tenant members
export const fetchMembers = createAsyncThunk(
    'tenant/fetchMembers',
    async (_, { dispatch }) => {
        try {
            const response = await axios.get('/api/tenant/members', getAuthHeader());
            return response.data;
        } catch(error) {
            dispatch(errorGlobal('Nepodarilo sa načítať členov subjektu.'));
            throw error;
        }
    }
);

// Remove tenant member
export const removeMember = createAsyncThunk(
    'tenant/removeMember',
    async (userId, { dispatch }) => {
        try {
            await axios.delete(`/api/tenant/members/${userId}`, getAuthHeader());
            dispatch(successGlobal('Prístup bol odobratý.'));
            return userId;
        } catch(error) {
            dispatch(errorGlobal(error.response?.data?.message || 'Chyba pri odobratí prístupu.'));
            throw error;
        }
    }
);

// Create tenant member (owner creates a login for a new user)
export const createMember = createAsyncThunk(
    'tenant/createMember',
    async (values, { dispatch }) => {
        try {
            const response = await axios.post('/api/tenant/members', values, getAuthHeader());
            if (response.data.invited) {
                dispatch(successGlobal('Používateľ je registrovaný v systéme. Bola mu odoslaná pozvánka.'));
            } else {
                dispatch(successGlobal('Používateľ bol vytvorený. Bol mu odoslaný email s nastavením hesla.'));
            }
            return response.data;
        } catch(error) {
            dispatch(errorGlobal(error.response?.data?.message || 'Chyba pri vytváraní používateľa.'));
            throw error;
        }
    }
);

// Set member's module access
export const setMemberModules = createAsyncThunk(
    'tenant/setMemberModules',
    async ({ userId, modules }, { dispatch }) => {
        try {
            await axios.patch(`/api/tenant/members/${userId}/modules`, { modules }, getAuthHeader());
            dispatch(successGlobal('Prístup k modulom bol upravený.'));
            return { userId, modules };
        } catch(error) {
            dispatch(errorGlobal(error.response?.data?.message || 'Chyba pri úprave prístupu.'));
            throw error;
        }
    }
);

// Upload Signature
export const uploadSignature = createAsyncThunk(
    'tenant/uploadSignature',
    async (file, { dispatch }) => {
        try {
            const formData = new FormData();
            formData.append('signature', file);
            const response = await axios.post('/api/tenant/signature', formData, getAuthHeader());
            dispatch(successGlobal('Podpis bol úspešne nahraný.'));
            return response.data;
        } catch(error) {
            dispatch(errorGlobal(error.response?.data?.message || 'Chyba pri nahrávaní podpisu.'));
            throw error;
        }
    }
);

// Delete Signature
export const deleteSignature = createAsyncThunk(
    'tenant/deleteSignature',
    async (_, { dispatch }) => {
        try {
            await axios.delete('/api/tenant/signature', getAuthHeader());
            dispatch(successGlobal('Podpis bol odstránený.'));
        } catch(error) {
            dispatch(errorGlobal(error.response?.data?.message || 'Chyba pri odstraňovaní podpisu.'));
            throw error;
        }
    }
);

// Update Tenant
export const updateTenant = createAsyncThunk(
    'tenant/updateTenant',
    async(values, { dispatch }) => {
        try {
            const branchId = values.branchId;
          
            const request = await axios.patch(`api/tenant/update`, { values, branchId }, getAuthHeader());
            dispatch(successGlobal('Subjekt bol úspešne upravený.'));
            return request.data;

        } catch(error) {
            dispatch(errorGlobal(error.response?.data?.message || 'Nastala chyba. Skúste to prosím znova.'));
            throw error;
        }
    }
);